import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import RegisterUser from '../Users/RegisterUser';
import { AppName } from '../../App';

const NoAccess = (props) => {
    const { CurrentUser } = props;
    const [loadingUser, setLoadingUser] = useState(!props.UserName);

    useEffect(() => {
        if (props.UserName
            || props.CurrentUser) {
            setLoadingUser(false);
        }
    }, [props.UserName, props.CurrentUser]);

    return (!loadingUser && (
        <Row>
            <Col lg="10" xl="8" className="text-center text-md-start">
                <div className="border-secondary pb-0 mb-2" style={{ borderBottomWidth: 2, borderBottomStyle: 'solid' }}>
                    <h3 className="d-none d-sm-inline-block d-md-none">{AppName}</h3>
                    <h2 className="d-inline-block d-sm-none d-md-inline-block">{AppName}</h2>
                </div>
                <RegisterUser user={CurrentUser} />
            </Col>
        </Row>
    ));
};

export default NoAccess;


// WEBPACK FOOTER //
// ./src/components/Shared/NoAccess.js